import { CheckCircle, XCircle, Clock, User, Lock, Bell } from "lucide-react";

export const SUBCITY_COORDS = {
  "Addis Ketema": [9.0317, 38.7367],
  "Akaky Kaliti": [8.8833, 38.7833],
  Arada: [9.0333, 38.75],
  Bole: [9.0, 38.7833],
  Gullele: [9.0667, 38.7167],
  Kirkos: [9.0167, 38.75],
  "Kolfe Keranio": [9.0167, 38.6833],
  Lideta: [9.0167, 38.7333],
  "Nifas Silk-Lafto": [8.9667, 38.7167],
  Yeka: [9.0333, 38.8167],
  "Lemi Kura": [9.05, 38.85],
};

export const statusConfig = {
  Completed: {
    bg: "bg-emerald-50 dark:bg-emerald-900/20",
    text: "text-emerald-700 dark:text-emerald-400",
    border: "border-emerald-100 dark:border-emerald-800",
    icon: CheckCircle,
  },
  Cancelled: {
    bg: "bg-red-50 dark:bg-red-900/20",
    text: "text-red-700 dark:text-red-400",
    border: "border-red-100 dark:border-red-800",
    icon: XCircle,
  },
  "Work Started": {
    bg: "bg-blue-50 dark:bg-blue-900/20",
    text: "text-blue-700 dark:text-blue-400",
    border: "border-blue-100 dark:border-blue-800",
    icon: Clock,
  },
  Pending: {
    bg: "bg-yellow-50 dark:bg-yellow-900/20",
    text: "text-yellow-700 dark:text-yellow-400",
    border: "border-yellow-100 dark:border-yellow-800",
    icon: Clock,
  },
  default: {
    bg: "bg-gray-50 dark:bg-gray-900/20",
    text: "text-gray-700 dark:text-gray-400",
    border: "border-gray-100 dark:border-gray-800",
    icon: Clock,
  },
};

// categoryIcons, categoryColors, categoryLabels, CATEGORIES removed.
// All category data is now fetched from the API via AdminContext.serviceCategories.

export const periodOptions = [
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" },
  { value: "custom", label: "Custom" },
];

export const faqs = [
  {
    q: "How do I add a new caregiver?",
    a: 'Go to the "Add Caregiver" page from the sidebar, fill in the required basic and service details, and click Submit. You can also import bulk data via CSV.',
  },
  {
    q: "Can I export client data?",
    a: 'Yes, navigate to the Clients page and click the "Export" button in the top right corner. The file will be downloaded in CSV format.',
  },
  {
    q: "How do I change my password?",
    a: "Go to Settings > Security and enter your current password followed by your new password. Make sure it is at least 8 characters long.",
  },
  {
    q: "What payment methods are supported?",
    a: "We currently support all major credit cards (Visa, Mastercard) and direct bank transfers for Pro accounts.",
  },
  {
    q: "How does matching work?",
    a: "Our algorithm matches caregivers to clients based on service type, location compatibility, and specific needs (e.g. language, medical conditions).",
  },
];
// Payment status constants
export const PAYMENT_STATUS = {
  SUCCESS: {
    label: "Completed",
    color:
      "text-emerald-600 bg-emerald-100 dark:text-emerald-400 dark:bg-emerald-900/30",
    icon: "CheckCircle",
  },
  PENDING: {
    label: "Pending",
    color:
      "text-yellow-600 bg-yellow-100 dark:text-yellow-400 dark:bg-yellow-900/30",
    icon: "Clock",
  },
  FAILED: {
    label: "Failed",
    color: "text-red-600 bg-red-100 dark:text-red-400 dark:bg-red-900/30",
    icon: "XCircle",
  },
  CANCELLED: {
    label: "Cancelled",
    color: "text-gray-600 bg-gray-100 dark:text-gray-400 dark:bg-gray-900/30",
    icon: "XCircle",
  },
  UNKNOWN: {
    label: "Unknown",
    color: "text-gray-600 bg-gray-100 dark:text-gray-400 dark:bg-gray-900/30",
    icon: "AlertCircle",
  },
};

// Time range options
export const TIME_RANGES = [
  { value: "7", label: "Last 7 days" },
  { value: "30", label: "Last 30 days" },
  { value: "90", label: "Last 90 days" },
  { value: "365", label: "Last year" },
];

// Group by options
export const GROUP_BY_OPTIONS = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
];

// Export range options
export const EXPORT_RANGES = [
  { value: "7", label: "Last 7 days" },
  { value: "30", label: "Last 30 days" },
  { value: "90", label: "Last 90 days" },
  { value: "365", label: "Last year" },
  { value: "730", label: "Last 2 years" },
  { value: "0", label: "All time" },
];

// Export format options
export const EXPORT_FORMATS = [
  { value: "excel", label: "Excel", icon: "FileSpreadsheet" },
  { value: "pdf", label: "PDF", icon: "FileText" },
];

// Avatar colors for user initials
export const AVATAR_COLORS = [
  "#EF4444",
  "#F59E0B",
  "#10B981",
  "#3B82F6",
  "#8B5CF6",
  "#EC4899",
  "#14B8A6",
  "#F97316",
  "#84CC16",
  "#6366F1",
];

// Chart color constants
export const CHART_COLORS = {
  SUBSCRIPTION: "#CE257A",
  MANUAL: "#3b82f6",
  TOTAL: "#10b981",
  PRIMARY: "#CE257A",
};

export const STAGES = [
  "Application_Submitted",
  "Document_Verification",
  "Guarantee_And_Medical_Test",
  "Interview",
  "Get_Exam",
  "Re_Examination",
  "Active",
];

export const statusMap = {
  pending: "Pending",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export const rawStatus = {
  Pending: "pending",
  Delivered: "delivered",
  Cancelled: "cancelled",
};

// Subcity options
export const SUBCITIES = [
  "Addis Ketema",
  "Akaki Kaliti",
  "Arada",
  "Bole",
  "Gullele",
  "Kirkos",
  "Kolfe Keranio",
  "Lideta",
  "Nifas Silk-Lafto",
  "Yeka",
  "Lemi Kura",
];

// Vetting status stages
export const VETTING_STAGES = [
  "All",
  "Application_Submitted",
  "Document_Verification",
  "Guarantee_And_Medical_Test",
  "Interview",
  "Get_Exam",
  "Re_Examination",
  "Active",
  "Onboarded",
  "Rejected",
];

// Display labels for vetting stages (for UI)
export const VETTING_STAGE_LABELS = {
  Application_Submitted: "Application Submitted",
  Document_Verification: "Document Verification",
  Guarantee_And_Medical_Test: "Guarantee and Medical Test",
  Interview: "Interview",
  Get_Exam: "Get Exam",
  Re_Examination: "Re-examination",
  Active: "Active",
  Onboarded: "Onboarded",
  Rejected: "Rejected",
};

// tabs for account settings
export const tabs = [
  {
    id: "account",
    label: "Account",
    icon: User,
    desc: "Profile details & personal info",
  },
  { id: "security", label: "Security", icon: Lock, desc: "Password & 2FA" },
  {
    id: "notifications",
    label: "Notifications",
    icon: Bell,
    desc: "Email & SMS preferences",
  },
];

// Status options for dropdown of invoiceslist
export const statusOptions = [
  "All Invoices",
  "Overdue",
  "Paid",
  "Pending",
  "Not paid",
];

// Wage payment status options for dropdown
export const wageStatusOptions = [
  "All Payments",
  "Pending",
  "Success",
  "Failed",
  "Cancelled",
];

// format currency
export const formatCurrency = (amount) => {
  return `Br ${parseFloat(amount || 0).toFixed(2)}`;
};

// Work type options based on your model
export const workTypeOptions = [
  { value: "", label: "All Work Types" },
  { value: "part_time", label: "Part Time" },
  { value: "on_demand", label: "On Demand" },
  { value: "living_in", label: "Living In" },
  { value: "night_shift", label: "Night Shift" },
];

// Experience level options
export const experienceOptions = [
  { value: "", label: "All Experience Levels" },
  { value: "1-5", label: "1-5 years" },
  { value: "6-10", label: "6-10 years" },
  { value: "11-15", label: "11-15 years" },
  { value: "15-20", label: "15-20 years" },
];
export const TUTOR_LEVELS = [
  "Elementary",
  "Middle School",
  "High School",
  "Preparatory",
  "University/College",
];
export const CHILDCARE_AGES = ["NEW_BORN", "TODDLER", "SCHOOL_AGE", "ALL_AGES"];

export const WORK_HOUR_OPTIONS = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
  { value: "night", label: "Night" },
  { value: "whole day", label: "Whole Day" },
];
export const WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const FAMILY_SIZES = ["small", "medium", "large"];

export const EXPERIENCE_LEVELS = ["1-5", "6-10", "11-15", "15-20"];
export const LANGUAGES = ["English", "Afaan Oromoo", "Amharic", "Tigrinya"];

// CATEGORIES_ICONS removed — use AdminContext.serviceCategories for category display data.

export const ELDERLY_CARE_NEEDS = [
  {
    key: "elderly_care_experience",
    label: "Elderly Care Experience",
  },
  {
    key: "first_aid_cpr_certified",
    label: "First Aid / CPR Certified",
  },
  {
    key: "medication_management",
    label: "Medication Management",
  },
  { key: "mobility_assistance", label: "Mobility Assistance" },
  { key: "meal_preparation", label: "Meal Preparation" },
  { key: "light_housekeeping", label: "Light Housekeeping" },
  {
    key: "transportation_assistance",
    label: "Transportation Assistance",
  },
  { key: "companionship", label: "Companionship" },
];
